import React, { useEffect, useState } from "react";
import axios from "../../../services/axios";
import { DropdownV2 } from "../../FormControlsV2";
import { IOptionProps, IOptionsProps } from "../../../@types/reactSelect/IOption";
import { useTaskCreation } from "../../../hooks/useTaskCreation";

function formatMachineTypeLabel(name: string): string {
  if (!name) return name;
  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
}

interface SoilPreparationProps { }

export const SoilPreparation: React.FC<SoilPreparationProps> = () => {
  const [machineTypeOptions, setMachineTypeOptions] = useState<IOptionsProps>(
    []
  );
  const [selectedMachine, setSelectedMachine] = useState<IOptionProps | null>(null);

  const {
    payload,
    setPayload,
    setAllowTaskCreation,
    responsibleId,
    microAreaId,
  } = useTaskCreation();

  useEffect(() => {
    axios
      .get("/tasks/soil-preparation/machine-types")
      .then((response) => {
        setMachineTypeOptions(
          response.data.map((machineType: { name: string; id: number }) => ({
            label: formatMachineTypeLabel(machineType.name),
            value: machineType.id,
          }))
        );
      })
      .catch((error) => console.log(error));
  }, []);

  const handleMachineTypeChoice = (opt: IOptionProps | null) => {
    setSelectedMachine(opt);
    const machineId = opt?.value;
    if (machineId === undefined || machineId === null) return;
    const changes = {
      micro_area_id: microAreaId,
      assigned_user_id: responsibleId,
      machine_type_id: machineId,
    };
    setPayload({ ...payload, changes: [changes] });
    setAllowTaskCreation(true);
  };

  return (
    <>
      <DropdownV2
        name="soil-preparation-machine"
        placeholder="Selecionar implemento a ser feito no solo..."
        label="Implemento"
        options={machineTypeOptions}
        value={selectedMachine}
        menuMount="overlay"
        onChange={(opt) => handleMachineTypeChoice(opt)}
      />
    </>
  );
};
